import { render, staticRenderFns } from "./WorkstationScanProducts.vue?vue&type=template&id=4a18309a"
import script from "./WorkstationScanProducts.vue?vue&type=script&lang=js"
export * from "./WorkstationScanProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports